import { MissionToExternalStaff } from '../../lib/types/models/mission-to-external-staff/mission-to-external-staff'
import { MissionToExternalStaffParams } from '../../lib/types/models/mission-to-external-staff/mission-to-external-staff-params'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function cancelExternalStaff(input: MissionToExternalStaffParams) {
  const { id, externalStaffId } = input
  return restApiClient
    .url(constructApiUrl(API.missions.cancelExternalStaff.url, { id, externalStaffId }))
    .post<MissionToExternalStaff>()
}
